import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Category } from '../types';
//
// Список категорий мероприятий
//
export type CategoriesState = Category[];
const initialState = [] as CategoriesState; 

export const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        categoriesSet: (state, action: PayloadAction<CategoriesState>) => {
            return action.payload;
        },
    }
});

export const { categoriesSet } = categoriesSlice.actions;
export default categoriesSlice.reducer;
